export {
  acceptJobOffer,
  createCvByType,
  createInitialCv,
  cvExperienceEndorsement,
  cvSkillEndorsement,
  deleteCvByType,
  fetchCvCompanies,
  fetchCvDetail,
  fetchCvPositions,
  fetchCvSchools,
  fetchCvSkills,
  getCvReviewers,
  getJobOfferList,
  updateCvByType,
  updateCvVisibleCourse,
  updateCvVisibleTestly,
  uploadProfileImage,
  uploadTrainingCertificate,
  type AcceptJobOfferPayload,
} from '@/features/cv/api/cv.api';

export { cvQueryKeys } from '@/features/cv/api/cv.keys';

export {
  useAcceptJobOffer,
  useCreateCv,
  useCvAnket,
  useCvExperienceEndorsement,
  useCvSkillEndorsement,
  useCvSkillSearch,
  useDeleteCv,
  useDeleteExamItem,
  useDeleteInternshipItem,
  useDeleteTrainingItem,
  useGenerateCvAiAbout,
  useGetCvCompanies,
  useGetCvPositions,
  useGetCvReviewers,
  useGetCvSchools,
  useGetJobOffers,
  useMyCv,
  useSaveExam,
  useSaveInternship,
  useUpdateCv,
  useUpdateCvVisibleCourse,
  useUpdateCvVisibleTestly,
  useUploadProfileImage,
  useUploadTrainingCertificate,
} from '@/features/cv/api/cv.queries';

export type {
  PositionOption,
  PositionParent,
  PositionsResponse,
} from '@/features/cv/types/position.types';

export {
  fetchCvAiAbout,
  fetchCvAiCareer,
  fetchCvAiCareerHistory,
  fetchCvAiEnhancePhoto,
  fetchCvAiSuggest,
  fetchCvAiSuggestHistory,
  fetchCvAiUsage,
  uploadCvAi,
} from '@/features/cv/api/ai.api';

export { aiQueryKeys } from '@/features/cv/api/ai.keys';

export {
  useCvAiCareerHistory,
  useCvAiEnhancePhoto,
  useCvAiSuggestHistory,
  useCvAiUsage,
  useGenerateCvAiCareer,
  useGenerateCvAiSuggest,
  useUploadCvAi,
} from '@/features/cv/api/ai.queries';
